import colors from './colors';
import borders from './borders';
import sizing from './sizing';
import utility from './utility';
const disabledInputStyles = {
    ...borders.disabled,
    color: colors.neutrals.textGamma,
    cursor: 'not-allowed'
};
const inputs = {
    base: {
        boxSizing: 'border-box',
        fontFamily: 'Gilroy, Monserrat, "Open Sans", Arial, Helvetica, sans-serif',
        lineHeight: '6rem',
        fontSize: '1.6rem',
        fontWeight: 600,
        color: colors.neutrals.textAlpha,
        backgroundColor: colors.neutrals.transparent,
        ...borders.base,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: sizing.component.padding.regular,
        paddingRight: sizing.component.padding.regular,
        outline: 'none',
        backgroundClip: 'padding-box'
    },
    disabled: {
        borderColor: colors.neutrals.borderBeta,
        color: colors.neutrals.borderBeta,
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    size: {
        small: {
            lineHeight: '2.4rem',
            fontSize: '1.2rem'
        },
        regular: {
            lineHeight: '4.8rem',
            fontSize: '1.6rem'
        },
        large: {
            lineHeight: '6rem',
            fontSize: '1.6rem'
        }
    },
    width: {
        natural: {},
        large: { minWidth: '28rem', display: 'block' },
        full: { width: '100%' }
    },
    shape: borders.shape,
    buttonStyles: {
        base: {
            fontWeight: 700
        },
        variant: {
            primary: {
                ...borders.variant.primary,
                backgroundColor: colors.brand.primary.alpha,
                color: colors.neutrals.background
            },
            secondary: {
                borderColor: colors.neutrals.transparent
            },
            inverted: {
                ...borders.variant.inverted,
                backgroundColor: colors.neutrals.background
            },
            outline: {
                ...borders.variant.primary,
                backgroundColor: colors.neutrals.transparent
            },
            outlineSecondary: {
                ...borders.variant.secondary,
                backgroundColor: colors.neutrals.transparent
            },
            invertedOutline: {
                ...borders.variant.invertedOutline,
                backgroundColor: colors.neutrals.transparent,
                color: colors.neutrals.background
            }
        },
        disabled: {
            primary: {
                ...disabledInputStyles,
                backgroundColor: colors.neutrals.borderBeta
            },
            secondary: disabledInputStyles,
            inverted: {
                ...disabledInputStyles,
                backgroundColor: colors.neutrals.borderBeta
            },
            outline: {
                ...disabledInputStyles,
                backgroundColor: colors.neutrals.borderBeta
            },
            outlineSecondary: {
                color: colors.neutrals.borderBeta,
                borderColor: colors.neutrals.borderBeta,
                cursor: 'not-allowed'
            },
            invertedOutline: {
                ...disabledInputStyles,
                backgroundColor: colors.neutrals.borderBeta
            }
        },
        hovered: {
            primary: {
                backgroundColor: colors.addition.primary,
                borderColor: colors.addition.primary,
                cursor: 'pointer'
            },
            secondary: {
                ...borders.variant.secondary,
                cursor: 'pointer'
            },
            inverted: {
                backgroundColor: colors.neutrals.textAlpha,
                borderColor: colors.neutrals.textAlpha,
                color: colors.neutrals.background,
                cursor: 'pointer'
            },
            outline: {
                borderColor: colors.neutrals.textAlpha,
                color: colors.neutrals.textAlpha,
                cursor: 'pointer'
            },
            outlineSecondary: {
                borderColor: colors.neutrals.textAlpha,
                color: colors.neutrals.textAlpha,
                cursor: 'pointer'
            },
            invertedOutline: {
                ...borders.variant.primary,
                color: colors.brand.primary.alpha,
                cursor: 'pointer'
            }
        }
    },
    choiceStyles: {
        base: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            padding: `${sizing.component.padding.small} ${sizing.component.padding.regular}`
        },
        hovered: {
            backgroundColor: colors.neutrals.borderBeta
        },
        focused: {
            boxShadow: `0px 0px 0px 6px ${colors.brand.secondary.beta}`
        }
    },
    selectStyles: {
        wrapper: {
            boxSizing: 'border-box',
            ...utility.size.fullWidthStyles,
            ...borders.base,
            overflow: 'visible',
            borderRadius: '2.6rem',
            color: colors.neutrals.textAlpha,
            position: 'relative'
        },
        trigger: {
            ...utility.accessiblyHidden,
            ...utility.size.fullSize
        }
    },
    utilityIconStyles: {
        position: 'absolute',
        right: '2.4rem',
        top: '4.2rem'
    }
};
export default inputs;
//# sourceMappingURL=inputs.js.map